import { render, staticRenderFns } from "./SuperSubmitButton.vue?vue&type=template&id=0c15645a&scoped=true"
import script from "./SuperSubmitButton.vue?vue&type=script&lang=js"
export * from "./SuperSubmitButton.vue?vue&type=script&lang=js"
import style0 from "./SuperSubmitButton.vue?vue&type=style&index=0&id=0c15645a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15645a",
  null
  
)

export default component.exports